<div id="mail-confirm" fxLayout="column" fusePerfectScrollbar>

    <div id="mail-confirm-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="mail-confirm-form" *fuseIfOnDom [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <mat-icon class="s-96">email</mat-icon>
            </div>

            <div class="title">Überprüfen Sie Ihre E-Mail-Adresse!</div>

            <div class="subtitle">
                <p>
                  Eine Reset-E-Mail wurde an gesendet <b>{{email}}</b>.
                </p>
                <p>
                  Überprüfen Sie Ihren Posteingang und klicken Sie auf den Link "Passwort ändern", um das Passwort zu ändern.
                </p>
            </div>

            <!--<div class="message">-->
                <!--&lt;!&ndash;<a class="link" [routerLink]="'/pages/auth/login'">Go back to login page</a>&ndash;&gt;-->
            <!--</div>-->

        </div>

    </div>

</div>
